const productList = [
  {
    id: "adloda-ex",
    name: "Adloda-EX",
    tagline: "Cough & Cold Remedy",
    shortDescription: "Fast-acting herbal syrup for respiratory relief and immunity, trusted across generations.",
    description: "Fast-acting herbal syrup for respiratory relief and immunity. Adloda-EX provides effective relief from cough, cold, and congestion using traditional Ayurvedic herbs. A widely recognized over-the-counter product, trusted across generations.",
    category: "Respiratory",
    size: "100ml",
    image: "https://customer-assets.emergentagent.com/job_ayurmed-india/artifacts/wyn0dyv8_2E972BA1-B9DD-48E3-B7C7-7AF9FA251D9B.png",
    homeImage: "https://customer-assets.emergentagent.com/job_a2fbe1d7-6ea8-4e85-b2df-dd1bbccb4e13/artifacts/myl51zao_IMG_2759.jpg",
    bgColor: "#f0d194",
    benefits: "Provides quick relief from cough|Clears nasal and chest congestion|Soothes sore throat|Boosts respiratory immunity|Safe for regular use",
    ingredients: "Vasa|Sundi|Maricha|Pipali|Dhashmoola|Yashttimadu|Thulasi|Eala|Elavangan|Pachila|Naga Pushpam|Eruveli|Dathki|Jaggery|Madu|Pachakarpooram",
    usage: "Oral syrup. Take as per dosage.",
    dosage: "Adults: 10ml to 15ml thrice daily. Children: 5ml to 10ml thrice daily. Do not use for children under 3 years old."
  },
  {
    id: "adloda-ds",
    name: "Adloda-DS",
    tagline: "Advanced Cough & Cold Remedy",
    shortDescription: "Double strength formula for severe cold and congestion with non-drowsy relief.",
    description: "Double strength formula for severe cold and congestion. Adloda-DS is specially formulated for those needing stronger relief from persistent respiratory issues.",
    category: "Respiratory",
    size: "100ml",
    image: "https://customer-assets.emergentagent.com/job_ayurmed-india/artifacts/4vczim7s_B38AB05E-E801-4886-B64E-DA52688E73F5.png",
    homeImage: "https://customer-assets.emergentagent.com/job_a2fbe1d7-6ea8-4e85-b2df-dd1bbccb4e13/artifacts/sym1gwlx_IMG_2762.jpg",
    bgColor: "#77c9e6",
    benefits: "Double strength for severe symptoms|Faster relief from persistent cough|Effective against chronic congestion|Supports lung health|Non-drowsy formula",
    ingredients: "Adaloda|Dhashamoola|Chukku|Kurumulaku|Thippali|Eratimadhuram|Thulasi|Elakka|Elavangam|Nagakesaram|Thakkolam|Iruveli|Thathiri Poovu|Sharkara|Karpooram|Puthina|Madhu",
    usage: "Oral syrup. Take as per dosage.",
    dosage: "Adults: 10ml to 15ml thrice daily. Children: 5ml to 10ml thrice daily. Do not use for children under 3 years old."
  },
  {
    id: "rasna-gulgulu",
    name: "Rasna Gulgulu (Quath)",
    tagline: "Joint & Body Pain Remedy",
    shortDescription: "Traditional Ayurvedic formulation for relief from joint pain and inflammation.",
    description: "Traditional Ayurvedic formulation for relief from joint pain and inflammation. This time-tested remedy combines powerful herbs known for their anti-inflammatory and analgesic properties.",
    category: "Pain Relief",
    size: "200ml",
    image: "https://customer-assets.emergentagent.com/job_ayurmed-india/artifacts/jdbav56b_7D34752A-B496-4E6A-8B34-F80C803C7184.png",
    homeImage: "https://customer-assets.emergentagent.com/job_a2fbe1d7-6ea8-4e85-b2df-dd1bbccb4e13/artifacts/0holc19d_IMG_2760.jpg",
    bgColor: "#fbd09f",
    benefits: "Relieves joint pain and stiffness|Reduces inflammation naturally|Improves joint mobility|Supports bone health|Provides relief from arthritis symptoms",
    ingredients: "Kizhar Nelli|Adalodaka|Kachoori|Avanakku|Kattu Mulaku|Kallur Vanchi|Cheru Teek|Karinkurunchi|Chukku|Koduveli|Dasamoolam|Aratha|Muthanga|Nellikka|Padavalam|Pushkaramoolam|Varattumanjal|Devadaram|Gulgulu",
    usage: "Quath (decoction). Shake well before use. Dilute as directed before drinking.",
    dosage: "15ml mixed with 30ml sterilized water, twice daily before food or as directed by physician."
  },
  {
    id: "thara-gith",
    name: "Thara Gith",
    tagline: "Hair Care Herbal Oil",
    shortDescription: "Premium herbal oil for nourishing hair roots and promoting healthy, lustrous hair.",
    description: "A premium herbal blend for nourishing hair roots and styling naturally. Thara Gith combines the ancient wisdom of Ayurveda with carefully selected herbs to promote healthy, lustrous hair.",
    size: "100ml",
    category: "Hair Care",
    image: "https://customer-assets.emergentagent.com/job_ayurmed-india/artifacts/w7p6bwq7_4010B370-F7B4-4B23-ADAD-1D0A24927993.png",
    homeImage: "https://customer-assets.emergentagent.com/job_a2fbe1d7-6ea8-4e85-b2df-dd1bbccb4e13/artifacts/5jkp65r9_IMG_2761.jpg",
    bgColor: "#ebcb92",
    benefits: "Strengthens hair roots and reduces hair fall|Promotes natural hair growth|Nourishes scalp and prevents dandruff|Provides cooling sensation and promotes sound sleep|Helps in styling without chemicals",
    ingredients: "Nimba|Kumari|Thambooli|Suparna|Jamba|Amlaka|Kanaka|Ajaksheera|Kerthaila|Kanaka Seed|Yashti Madu|Usheera",
    usage: "Clean your head and hair well. Apply Thara Gith oil and massage thoroughly. Leave for at least 30 minutes. Wash off with a mild herbal shampoo.",
    dosage: "External use only. Use 2-3 times per week for optimal results."
  },
  {
    id: "rithu",
    name: "Rithu",
    tagline: "Uterine Tonic",
    shortDescription: "Holistic Ayurvedic tonic for women's health and hormonal balance.",
    description: "Holistic care for women's health and hormonal balance. Rithu is a comprehensive Ayurvedic tonic designed to support women's reproductive health through all stages of life.",
    category: "Women's Health",
    size: "210ml",
    image: "https://customer-assets.emergentagent.com/job_ayurmed-india/artifacts/yk6tuqzv_83593C1C-7D9C-4D44-8D47-547629B43921.png",
    homeImage: "https://customer-assets.emergentagent.com/job_a2fbe1d7-6ea8-4e85-b2df-dd1bbccb4e13/artifacts/w1xdcg0q_IMG_2763.jpg",
    bgColor: "#edc1bc",
    benefits: "Supports menstrual health|Helps regulate hormonal balance|Strengthens uterine health|Reduces menstrual discomfort|Promotes overall women's wellness",
    ingredients: "Musli|Khadira|Amalaka|Trikandaka|Jambu|Ashoka|Usira|Bala|Kerapushpam|Chandanam|Dhataki|Jaggery|Madhu",
    usage: "Oral tonic. Shake well before use.",
    dosage: "10ml to 15ml, 3 times daily before meals or as directed by physician."
  }
];

export const products = productList.map(p => ({
  ...p,
  benefits: p.benefits.split('|'),
  ingredients: p.ingredients.split('|')
}));

export const getProductById = (id) => {
  return products.find(product => product.id === id);
};
